import { mapEnumToOptions } from '@abp/ng.core';

export enum ProviderState {
  Inactive = 0,
  Active = 1,
}

export const providerStateOptions = mapEnumToOptions(ProviderState);
